// extracted by mini-css-extract-plugin
export default {"pageContent":"about_pageContent__tRLWg"};